import React from "react";
import FAQ from "../../Assets/Images/Faq.png";
import { Markup } from "interweave";

export default function FAQCard({ title, description }) {
  
  return (
    <>
    
    
    <div >
      <div className="left-col-box mt-3 rounded pb-3">
        <h5 className="text-center py-4 ">
          <img src={FAQ} alt="" />
        </h5>
        <div className="bg-about mx-3 p-2 text-light  rounded ">
          <div class="accordion" id="accordionExample">
          {description&&description.map((data, i) => (
    
            <div class="accordion-item bg-dark mb-3" key={i}>
              <h2 class="accordion-header faq" id={`headingOne_${i}`}>
                <button
                  class="accordion-button bg-dark text-light"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapseOne_${i}`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                {data.title}
                   
                </button>
              </h2>
              <div
                id={`collapseOne_${i}`}
                class="accordion-collapse collapse hide"
                aria-labelledby={`headingOne_${i}`}
                data-bs-parent="#accordionExample"
              >
                <div className="p-3 text-light">
              
                  <Markup content={data.details}></Markup>
                </div>
              </div>
            </div>
            ))} 
          </div>
        </div>
      </div>
    </div>
    
   
   </>
     
  );
}
